import { EnvironmentProviders } from '@angular/core';
import { LogLevel, provideAuth } from 'angular-auth-oidc-client';
import { environment } from '@/environments/environment';

/**
 * OIDC config — Authorization Code + PKCE against the Identity server itself.
 * Renewal is refresh-token based (`offline_access`); iframe silent-renew is
 * blocked by the backend's `X-Frame-Options: DENY` / CSP `frame-ancestors 'none'`.
 * User identity/permissions come from the GraphQL `Me` query, not /userinfo.
 */
export const authConfig: EnvironmentProviders = provideAuth({
    config: {
        authority: environment.issuer,
        clientId: environment.clientId,
        redirectUrl: environment.redirectUrl,
        postLogoutRedirectUri: environment.postLogoutRedirectUri,
        scope: environment.scope,
        responseType: 'code',
        useRefreshToken: true,
        silentRenew: true,
        renewTimeBeforeTokenExpiresInSeconds: 30,
        autoUserInfo: false,
        ignoreNonceAfterRefresh: true,
        secureRoutes: [environment.graphqlEndpoint],
        logLevel: environment.production ? LogLevel.Error : LogLevel.Warn
    }
});
